<template>
  <div class="account-page scrollable">
    <div class="page-header">
      <h1>Phones List</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Phone Table</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="top-bar">
      <div class="count-user">
        <p>Total Phone Count: {{ PhoneTableGroup.length }}</p>
      </div>
    </div>

    <el-form inline>
      <el-form-item>
        <el-input v-model="inputURL" placeholder="EX.: 95.164.109.200" :style="{ 'width': '400px' }"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button v-if="isAdmin" type="info" @click="">
          <i class="mdi mdi-magnify"></i> Find Phone
        </el-button>
      </el-form-item>
    </el-form>

    <div class="top-bar">

      <div class="accounts-filter">
        Show
        <el-select
            v-model="countTinderAccounts"
            @change="changeCount"
            placeholder=" "
            style="width:70px"
        >
          <el-option
              v-for="item in countPhoneOptions"
              :key="item.value"
              :label="item.value"
              :value="item.value"
          >
          </el-option>
        </el-select>
        entries
      </div>

      <div class="header-buttons">
        <el-button v-if="isAdmin"
                    type="primary"
                    @click="goToAddTinderAccount"
        >+ Add Phone
        </el-button>          
      </div>      
    </div> 

    <el-table ref="indexingTable" :data="PhoneTableGroup" style="width: 100%;" @sort-change="sort" @filter-change="filterChange" :row-class-name="rowClassName">
      <el-table-column prop="checkbox" :width="50">
        <template slot="header" slot-scope="scope">
          <span class="no-wrap-cell">#</span>
        </template>
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.checkbox"></el-checkbox>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" sort-key="created_at" :min-width="50">
        <template slot="header" slot-scope="scope">
          <div :style="{ textAlign: 'center' }">
            <span>Phone ID</span>
          </div>
        </template>
        <template slot-scope="scope">
          <div :style="{ textAlign: 'center' }">{{ scope.row.phone_id }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" sort-key="created_at" :min-width="130">
        <template slot="header" slot-scope="scope">
          <div :style="{ textAlign: 'center' }">
              <span>Status</span>
          </div>
        </template>
        <template slot-scope="scope">
          <div :style="{ color: '#00e500', textAlign: 'center' }" v-html="scope.row.status"></div>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" sort-key="created_at" :min-width="130">
        <template slot="header" slot-scope="scope">
          <div :style="{ textAlign: 'center' }">
            <span>Phone</span>
          </div>
        </template>
        <template slot-scope="scope">
          <div :style="{ textAlign: 'center' }">{{ scope.row.phone }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" sort-key="created_at" :min-width="130">
        <template slot="header" slot-scope="scope">
          <div :style="{ textAlign: 'center' }">
            <span>Proxy</span>
          </div>
        </template>
        <template slot-scope="scope">
          <div :style="{ textAlign: 'center' }">{{ scope.row.proxy_address }}</div>
        </template>
      </el-table-column>  
      
      <el-table-column prop="created_at" sort-key="created_at" :min-width="130">
        <template slot="header" slot-scope="scope">
          <div :style="{ textAlign: 'center' }">
            <span>Tinder ID</span>
          </div>
        </template>
        <template slot-scope="scope">
          <div :style="{ textAlign: 'center' }">{{ scope.row.tinder_id }}</div>
        </template>
      </el-table-column> 
      
      <el-table-column prop="created_at" sort-key="created_at" :min-width="130">
        <template slot="header" slot-scope="scope">
          <div :style="{ textAlign: 'center' }">
            <span>City</span>
          </div>
        </template>
        <template slot-scope="scope">
          <div :style="{ textAlign: 'center' }">{{ scope.row.city }}</div>
        </template>
      </el-table-column>       
      
      <!-- actions -->
      <el-table-column label="Operations" width="260px">
        <template slot-scope="scope">
          <el-button v-if="isAdmin"
                     size="mini"
                     type="info"
                     :disabled="isAnyRowSelected()"
                     @click="handleEdit(scope.$index, scope.row)"
          ><i class="mdi mdi-pencil"></i> Edit 
          </el-button>          
          <el-button v-if="isAdmin"
                     size="mini"
                     type="danger"
                     :disabled="isAnyRowSelected()"
                     @click=""
          ><i class="mdi mdi-delete"></i> Delete 
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagin-wrp">
      <el-pagination
          :background="true"
          layout="prev, pager, next"
          :page-size="PhoneTableGroup.length"
          :total="PhoneTableGroup.length"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import HeaderSortTitle from '../../components/UsersList/HeaderSortTitle'
import axios from 'axios'

export default {
  name: 'IndexingPages',
  components: {
    
  },
  data () {
    return {
      filterBlock:{},
      inputURL: '',
      sortBy: {
        autoscan: 0,
        status: 0,
        account_group_id: 0,
        created_at: 0,
      },
      filterTinderAccounts: '',
      countTinderAccounts: 10,
      countPhoneOptions: [
        {value: 10},
        {value: 25},
        {value: 50},
        {value: 100},
      ],
      vnc_server: `${process.env.VUE_APP_VNC_SERVER}`,
      usersCount: 0,
      showByStatus: 0,
      isSubmitedAuthorize: false,
      isIndexClicked: null,
      statusOptions: [
        {
          value: 'blocked',
          label: 'blocked',
          text: 'Blocked'

        },
        {
          value: 'active',
          label: 'active',
          text: 'Active'
        },
        {
          value: 'verification',
          label: 'verification',
          text: 'Verification'
        }
      ],
      showByAccountGroup: 0,

      selectedRows: [],
      PhoneTableGroup: [
        {
          checkbox: false,
          phone_id: '1',
          status: '<i class="mdi mdi-checkbox-blank-circle"></i> +18027154206<br> 2024-01-18 2:15 pm',
          phone: '+18027154206',
          proxy_address: '95.164.109.200',
          tinder_id: 11,
          city: 'New York',
        },
        {
          checkbox: false,
          phone_id: '2',
          status: '<i class="mdi mdi-checkbox-blank-circle"></i> +18027154206<br> 2024-01-18 2:15 pm',
          phone: '+18027154206',
          proxy_address: '95.164.109.200',
          tinder_id: 11,
          city: 'New York',
        },
        {
          checkbox: false,
          phone_id: '3',
          status: '<i class="mdi mdi-checkbox-blank-circle"></i> +18027154206<br> 2024-01-18 2:15 pm',
          phone: '+18027154206',
          proxy_address: '95.164.109.200',
          tinder_id: 11,
          city: 'New York',
        },
        {
          checkbox: false,
          phone_id: '4',
          status: '<i class="mdi mdi-checkbox-blank-circle"></i> +18027154206<br> 2024-01-18 2:15 pm',
          phone: '+18027154206',
          proxy_address: '95.164.109.200',
          tinder_id: 11,
          city: 'New York',
        },
        {
          checkbox: false,
          phone_id: '5',
          status: '<i class="mdi mdi-checkbox-blank-circle"></i> +18027154206<br> 2024-01-18 2:15 pm',
          phone: '+18027154206',
          proxy_address: '95.164.109.200',
          tinder_id: 11,
          city: 'New York',
        },                             

      ],
      chosenPage: 1,
    }
  },
  computed: {
    ...mapGetters({
      user: 'userData',
      tinderAccounts: 'tinderAccounts/getTinderAccounts',
      tinderAccountsMeta: 'tinderAccounts/getTinderAccountsMeta',
      paidProxies: 'tinderAccounts/getPaidProxies',
      phoneProviders: 'tinderAccounts/getPhoneProviders',
      tinderAccountGroups: 'tinderAccounts/getTinderAccountGroups'
    }),

    isAdmin() {
      return this.user? this.user.is_admin:false;
    },

   

  },
  mounted () {
    this.$store.dispatch('tinderAccounts/getTinderAccounts')
    this.$store.dispatch('tinderAccounts/getTinderAccountGroups')
    axios
        .get(`${process.env.VUE_APP_TINDERSTORE_URL}/api/user/total`)
        .then((response) => {
          this.usersCount = response.data.total;
        })
        .catch(error => console.log(error));
  },
  methods: {
    isAnyRowSelected() {
      return this.PhoneTableGroup.some(row => row.checkbox);
    },     
    rowClassName({ row }) {
      return row.checkbox ? 'selected-row' : '';
    },    
    choosePage (e) {
      this.chosenPage = e
      this.updateList()
    },
    filterChange(filter) {
      Object.assign(this.filterBlock, filter)
      this.updateList()
    },
    sort(by) {
      let key  = (typeof by ==="object") ? by.prop : by

      if (this.sortBy[key] === 0) {
        this.sortBy[key] = 1
      } else if (this.sortBy[key] === 1) {
        this.sortBy[key] = -1
      } else if (this.sortBy[key] === -1) {
        this.sortBy[key] = 0
      }
      if(typeof by ==="object" && by.order==null){
        this.sortBy[key] = 0
      }
      this.updateList()
    },
    getFilters() {
      let params = 'sort='
      if (this.sortBy) {
        for (let itm in this.sortBy) {
          if (this.sortBy[itm] === 1) {
            params = `${params}${itm},`
          } else if (this.sortBy[itm] === -1) {
            params = `${params}-${itm},`
          }
        }
      }
      if (params === 'sort=') {
        params = ''
      }
      params = `${params}&page=${this.chosenPage}`
      if (this.countTinderAccounts) {
        params = `${params}&per_page=${this.countTinderAccounts}`
      }

      if (this.showByAccountGroup != 0) {
        params = `${params}&group=${this.showByAccountGroup}`
      }

      if (this.showByStatus != 0) {
        let status = this.statusOptions[this.showByStatus].label.toLowerCase();
        params = `${params}&status=${status}`
      }

      if (this.showByAutoscan != 3) {
        params = `${params}&autoscan=${this.showByAutoscan}`
      }

      if (this.filterTinderAccounts.length) {
        params = `${params}&filter=${this.filterTinderAccounts}`
      }

      if (Object.keys(this.filterBlock).length) {
        Object.entries(this.filterBlock).forEach(([key, value]) => {
          if(value.length === 0){
            return;
          }
          params = `${params}&${key}=`+JSON.stringify(value)
        });
      }

      return params;
    },
    changeCount (e) {
      this.countTinderAccounts = e
      this.updateList()
    },
    changeByAccountGroup(e) {
      this.showByAccountGroup = e
      this.updateList()
    },
    changeByStatus(e) {
      this.showByStatus = e
      this.updateList()
    },
    changeByAutoscan(e) {
      this.showByAutoscan = e
      this.updateList()
    },
    searchTinderAccounts (e) {
      this.filterTinderAccounts = e
      this.updateList()
    },
    updateList() {
      let params = this.getFilters();
      this.$store.dispatch('tinderAccounts/getTinderAccounts', params)
    },
    goToAddTinderAccount(){
      this.$router.push({name: 'phone-create'})
    },
    handleEdit (index, row) {
      this.$router.push({name: 'phone-edit', params: {id: row.id}})
    },
    handleDelete (data) {
      this.$store.dispatch('phoneTable/deletePhoneTable', data.id)
    },
    handleAuthorize (index, row) {
      this.isSubmitedAuthorize = true
      this.isIndexClicked = index
      this.$store.dispatch('tinderAccounts/authorizeTinderAccount', row.id)
          .then(response => {
            this.$notify.success({ title: 'Phone number #'+row.phone,  message: 'has beed success authorized.' })
          })
          .catch(error => {
            this.$notify.error({ title: 'Phone number #'+row.phone,  message: 'authorization error' })
          })
          .finally(() => {
            this.isSubmitedAuthorize = false
            this.isIndexClicked = null
            this.updateList()
          })
    }
  }
}
</script>

<style scoped lang="scss">

.account-page {
  overflow-x: hidden;
}
th {
  .cell {
    .pointer {
      cursor: pointer;
    }
  }
}

.accounts-filter {
  width: 200px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div {
    margin: 0 5px;
  }
}
.selected-row {
  background-color: red !important;
}
</style>
<style lang="scss">
.selected-row {
  background-color: #d8e2e942 !important;
}
</style>
